import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Newnavbar from "../Component/Newnavbar.js";
import Digitlfoodsidebar from "../Component/Digitalfood/Digitlfoodsidebar";
import Cateringservicesbanner from "../Component/Cateringservicesbanner";
import menu1 from "../Component/grocerybanner.png";
import "./housemaamaas.css";
import "./Style.css";
 import SidescrollAdvertisements from './SidescrollAdvertisements';

const Homemaamaas = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [coupons, setCoupons] = useState([]);
  const [bannerData, setBannerData] = useState(null);
  const scrollContainerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  const [orderType, setOrderType] = useState(null);
  const userId = localStorage.getItem("userId"); // 👈 fetch from localStorage

  useEffect(() => {
    const fetchOrderType = async () => {
      try {
        const res = await axios.get(
          ` https://backend.maamaas.com/food/api/cart/${userId}`
        );
        if (res.data && res.data.length > 0) {
          setOrderType(res.data[0].orderType);
        }
      } catch (err) {
        console.error("Error fetching order type:", err);
      }
    };

    if (userId) {
      fetchOrderType();
    }
  }, [userId]);



  useEffect(() => {
    const vendorId = localStorage.getItem("vendorId") || 3;
    axios
      .get(
        ` https://backend.maamaas.com/food/banner/vendor/${vendorId}`
      )
      .then((res) => {
        setBannerData({
          ...res.data,
          companyLogo: toImageSrc(res.data.companyLogo),
          companyName: res.data.companyName,
        });
      })
      .catch(() => { });
  }, []);

  const toImageSrc = (raw) => {
    if (!raw || raw.trim() === "/") return "/placeholder.svg";
    if (raw.startsWith("data:image")) return raw;
    if (/^https?:\/\//i.test(raw)) return raw;
    if (raw.length > 100) return `data:image/jpeg;base64,${raw}`;
    return "/placeholder.svg";
  };

  // ✅ Sidebar Items
  const sidebarItems = [
    {
      label: bannerData?.companyName || "Company Name",
      link: "/",
      img: bannerData?.companyLogo || "/placeholder.png",
    },
    ...(orderType === "TABLE_DINE_IN"
      ? [
        {
          label: "Table Booking",
          link: "/tablebooking",
          img: bannerData?.companyLogo || "/placeholder.png",
        },
      ]
      : [
        {
          label: "Menu",
          link: "/Newmenuiteam",
          img: bannerData?.companyLogo || "/placeholder.png",
        },
      ]),
  ];





  useEffect(() => {
    // Fetch coupons from API
    axios
      .get(
        " https://backend.maamaas.com/food/coupon/vendor/3/active"
      )
      .then((res) => {
        if (res.data) {
          setCoupons(res.data); // assuming API returns array of coupons
        }
      })
      .catch((err) => {
        console.error("Error fetching coupons:", err);
      });
  }, []);

  // ✅ Dummy Coupons (अगर API नहीं है तो ये चलेंगे)
  useEffect(() => {
    setCoupons([
      { code: "PIZZA50", discountPercentage: 50, dishId: 1 },
      { code: "BURGER30", discountPercentage: 30, dishId: 2 },
      { code: "DEL99", discountPercentage: 20, dishId: 3 },
    ]);
  }, []);

  // ✅ Dish Images
  const dishImages = {
    1: { image: menu1 },
    2: { image: menu1 },
    3: { image: menu1 },
  };

  return (
    <div>
      <Newnavbar />
      <Digitlfoodsidebar />

      <div className="container-fluid">
        <div className="row ms-0">
          {/* LEFT SIDEBAR */}
          <div className="col-lg-2 col-12 maamaas-home-data-top">
            {isMobile ? (
              <div className="d-flex flex-column align-items-start">
                {/* पहला item */}
                <div
                  className="d-flex align-items-center p-2 w-100"
                  style={{
                    background: "#fff",
                    border: "1px solid #ccc",
                    marginTop: "130px",
                    borderRadius: "8px",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src={sidebarItems[0].img}
                    alt={sidebarItems[0].label}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      marginRight: "10px",
                      objectFit: "cover",
                    }}
                  />
                  <Link
                    to={sidebarItems[0].link}
                    style={{
                      fontWeight: "bold",
                      color: "#333",
                      textDecoration: "none",
                    }}
                  >
                    {sidebarItems[0].label}
                  </Link>
                </div>

                {/* Dropdown */}
                <button
                  className="btn btn-primary w-100"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  {isOpen ? "Hide More ▲" : "Show More ▼"}
                </button>

                {isOpen && (
                  <div
                    className="d-flex flex-column mt-2 p-2 w-100"
                    style={{
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  >
                    {sidebarItems.slice(1).map((item, i) => (
                      <Link
                        key={i}
                        to={item.link}
                        className="d-flex align-items-center p-2"
                        style={{
                          textDecoration: "none",
                          borderBottom:
                            i !== sidebarItems.slice(1).length - 1
                              ? "1px solid #eee"
                              : "none",
                        }}
                      >
                        <img
                          src={item.img}
                          alt={item.label}
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            marginRight: "10px",
                            objectFit: "cover",
                          }}
                        />
                        <span style={{ fontWeight: "bold", color: "#333" }}>
                          {item.label}
                        </span>
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div className="row gx-0 ms-0">
                {sidebarItems.map((item, i) => (
                  <div
                    key={i}
                    className="card d-flex justify-content-center align-items-center text-center"
                    style={{
                      width: "180px",
                      height: "180px",
                      backgroundColor: "#D9D9D9",
                      marginBottom: "20px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={item.img}
                      alt={item.label}
                      style={{
                        borderRadius: "50%",
                        width: "130px",
                        height: "130px",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                    <Link
                      to={item.link}
                      className="btn mt-2"
                      style={{ backgroundColor: "#fff", fontWeight: "bold" }}
                    >
                      {item.label}
                    </Link>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* CENTER MENU */}
          <div className="col-lg-8 col-md-12 col-sm-12 col-12">
            {bannerData && (
              <p
                className="maamaas-home-bredcumsyy"
                style={{
                  marginTop: "75px",
                  fontSize: "18px",
                  marginLeft: "20px",
                  marginBottom: "0px",
                }}
              >
                <Link
                  to="/"
                  style={{
                    color: "#ee6521",
                    fontWeight: "bold",
                    textDecoration: "none",
                  }}
                >
                  Home
                </Link>
                <span className="separator"> &gt; </span>
                <span style={{ color: "#ee6521", fontWeight: "bold" }}>
                  {bannerData?.companyName || "Maamaas"}
                </span>
              </p>
            )}

            <div
              style={{
                maxHeight: "1500px",
                overflowY: "scroll",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              <Cateringservicesbanner />
            </div>
          </div>

          {/* RIGHT COUPONS */}
          <div
            className="col-lg-3"
            style={{ display: isMobile ? "none" : "block" }}
          >
            <div
           className="col-lg-3"
           style={{ display: isMobile ? "none" : "block" }}
         >
           <SidescrollAdvertisements/>
         </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homemaamaas;
